import chroma from 'chroma-js';

import { AppearanceVariablesKeys } from '@flywire/internal-components/services/iframeMessageBroker/model';

export const isValidRGBColor = (color: string | undefined) => {
  if (!color) return true;

  return chroma.valid(color);
};

export const errorMessageForColorVariable = (variable: AppearanceVariablesKeys) => {
  return `Invalid color format supplied for ${variable}, only HEX RGB color format is allowed. Example: #99FFCCFF`;
};
